(() => {
  const roots = document.querySelectorAll('[data-ics-product-listing]');

  roots.forEach((root) => {
    const panel = root.querySelector('[data-listing-panel]');
    const forms = root.querySelectorAll('[data-listing-navigation]');

    const setLoading = () => {
      if (panel) panel.setAttribute('aria-busy', 'true');
    };

    forms.forEach((form) => {
      form.addEventListener('submit', setLoading);
    });

    root.querySelectorAll('[data-auto-submit]').forEach((select) => {
      select.addEventListener('change', () => {
        setLoading();
        select.form?.requestSubmit();
      });
    });

    root.querySelectorAll('[data-listing-pagination] a').forEach((link) => {
      link.addEventListener('click', setLoading);
    });

    window.addEventListener('pageshow', () => {
      if (panel) panel.setAttribute('aria-busy', 'false');
    });
  });
})();
